import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  modalClose: {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    zIndex: 2
  },
  closeIcon: {
    width: 22,
    height: 22
  },
  modalText: {
    marginTop: "50px",
    marginBottom: "30px",
    textAlign: "center",
    padding: "5px"
  },
  closeBtn: {
    backgroundColor: "#0a182c",
    width: 100,
    marginBottom: 10,
    borderRadius: 10,
    height: 40
  },
  titleClose: {
    color: "#ffffff",
    fontSize: 12
  },
});

export default styles;
